import React from 'react'
import { theme } from 'antd'
import type { CustomTooltipProps } from 'ag-grid-react'

const CustomHeaderTooltip = ({ value }: CustomTooltipProps) => {
  const { token } = theme.useToken()

  if (!value) return null

  return (
    <div
      className="ant-tooltip"
      style={{
        backgroundColor: token.colorBgSpotlight,
        borderRadius: token.borderRadiusSM,
        padding: `${token.paddingXS}px ${token.paddingSM}px`,
        boxShadow: token.boxShadowSecondary,
        maxWidth: 280,
        fontSize: token.fontSizeSM,
        lineHeight: 1.5,
        color: token.colorTextLightSolid
      }}
    >
      {value}
    </div>
  )
}

export default CustomHeaderTooltip
